import { Avatar, Box, Stack } from "@mui/material";
import moment from "moment";
import React from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { allImages, appFonts } from "../../../assets";
import appcolors from "../../../constants/Colors";
import WorkerEvents from "./WorkerEvents";
import { t } from "i18next";

const localizer = momentLocalizer(moment);

const events = [
  {
    id: 1,
    title: "Hair Color",
    start: new Date(2024, 8, 24, 10, 2),
    end: new Date(2024, 8, 24, 10, 45),
    resourceId: "a",
    status: "New Appointment",
    price: 2899,
    type: "online",
    createdBy: "user",
  },
  {
    id: 2,
    title: "Face Massage",
    start: new Date(2024, 8, 24, 10, 0),
    end: new Date(2024, 8, 24, 10, 45),
    resourceId: "b",
    status: "Completed",
    price: 2899,
    type: "walk In",
    createdBy: "user",
  },
  {
    id: 3,
    title: "Hair Dying",
    start: new Date(2024, 9, 24, 10, 0),
    end: new Date(2024, 9, 24, 10, 45),
    resourceId: "c",
    status: "Accepted",
    price: 2899,
    type: "walk In",
    createdBy: "user",
  },
  {
    id: 4,
    title: "Blocked Time",
    start: new Date(2024, 7, 5, 10, 0),
    end: new Date(2024, 7, 5, 10, 45),
    resourceId: "d",
    status: "Blocked",
    price: 2899,
    type: "blocked",
    createdBy: "user",
  },
];

const resources = [
  { id: "a", title: "Sinan Lakhani", icon: allImages.dumyMen1 },
  { id: "b", title: "Ali Khan", icon: allImages.dumyMen2 },
  { id: "c", title: "Aneeq Khan", icon: allImages.dumyMen3 },
  { id: "d", title: "Rabeet Rabeet", icon: allImages.dumyMen4 },
  { id: "e", title: "Juniad Khan", icon: allImages.dumyUserImg },
  { id: "f", title: "Muhammad Masood", icon: "" },
];

const AppointmentCalendar = ({
  handleSelectEvent,
  allWorkers,
  allAppointments,
}) => {
  const resourceHeader = ({ label, resource }) => {
    return (
      <Stack m={2} justifyContent={"center"} alignItems={"center"}>
        <Box borderRadius={"100%"} border={`2px solid ${appcolors.primary}`}>
          <Avatar
            src={resource?.profileImg || resource?.name.charAt(1)}
            alt={resource?.name}
            sx={{
              height: 60,
              width: 60,
              border: `2px solid ${appcolors.white}`,
            }}
          />
        </Box>
        <span
          style={{
            fontFamily: appFonts.Poppins,
            fontSize: "0.75rem",
            fontWeight: 500,
          }}
        >
          {resource?.name}
        </span>
      </Stack>
    );
  };

  const eventStyleGetter = (event) => {
    let style = {
      borderRadius: "5px",
      color: "#000",
      display: "block",
    };

    if (event.status === "completed" && event.workerStatus === "accepted") {
      style.backgroundColor = "#D3FFE2";
      style.border = "2px solid #9ef9bd";
    } else if (
      event.status === "accepted" &&
      event.workerStatus === "accepted"
    ) {
      style.backgroundColor = "#FDEEE6";
      style.border = "2px solid #EA580C";
    } else if (
      event.status === "pending" &&
      event.workerStatus === "rejected"
    ) {
      style.backgroundColor = "rgb(250, 181, 160)";
      style.border = "2px solid rgb(255, 75, 20)";
    } else {
      style.backgroundColor = "#fcad389e";
      style.border = "2px solid #FCAD38";
    }

    return {
      className: "custom-event",
      style: style,
      title: "",
    };
  };

  const formats = {
    timeGutterFormat: (date, culture, localizer) =>
      localizer.format(date, "h:mm a", culture).replace(" ", "\n"),
    dayHeaderFormat: (date, culture, localizer) =>
      localizer.format(date, "dddd, MMMM DD, YYYY", culture),
  };

  return (
    <div>
      <Calendar
        localizer={localizer}
        events={allAppointments || []}
        startAccessor="start"
        endAccessor="end"
        resources={allWorkers}
        resourceIdAccessor="id"
        resourceTitleAccessor="title"
        selectable
        onSelectEvent={handleSelectEvent}
        defaultView="day"
        views={["day", "week"]}
        formats={formats}
        tooltipAccessor={() => null}
        step={15}
        timeslots={2}
        components={{
          resourceHeader,
          event: WorkerEvents,
        }}
        eventPropGetter={eventStyleGetter}
        style={{ height: "100vh" }}
        messages={{
          next: t("nexts"),
          previous: t("previous"),
          today: t("today"),
          month: t("month"),
          week: t("week"),
          day: t("day"),
        }}
      />
    </div>
  );
};

export default AppointmentCalendar;
